import { render, staticRenderFns } from "./MeusHorarios.vue?vue&type=template&id=118a958c"
import script from "./MeusHorarios.vue?vue&type=script&lang=js"
export * from "./MeusHorarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports